import { SOURCE_SYSTEMS } from './constants'

const StepMigrationDetails = ({ formData, onChange }) => {
  const handleChange = (e) => {
    const { name, value } = e.target
    onChange({ [name]: value })
  }

  const handleSourceSelect = (sourceId) => {
    onChange({ source_system: sourceId })
  }

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold text-[#111418] flex items-center gap-2">
        <span className="material-symbols-outlined text-primary">description</span>
        Migration Details
      </h2>

      {/* Migration Name */}
      <div className="flex flex-col gap-2">
        <label className="text-xs font-bold text-[#111418] uppercase tracking-wider">
          Migration Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          placeholder="e.g., Migration 2026-01-19"
          className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none text-sm"
        />
      </div>

      {/* Description */}
      <div className="flex flex-col gap-2">
        <label className="text-xs font-bold text-[#111418] uppercase tracking-wider">
          Description <span className="text-gray-400 font-normal normal-case">(optional)</span>
        </label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          rows={2}
          placeholder="Add any notes about this migration..."
          className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none text-sm resize-none"
        />
      </div>

      {/* Source System Cards */}
      <div className="flex flex-col gap-3">
        <label className="text-xs font-bold text-[#111418] uppercase tracking-wider">
          Source System <span className="text-red-500">*</span>
        </label>
        <p className="text-sm text-gray-500 -mt-1">Select the accounting software you&apos;re migrating from</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {SOURCE_SYSTEMS.map(system => (
            <button
              key={system.id}
              type="button"
              onClick={() => handleSourceSelect(system.id)}
              className={`flex flex-col items-center gap-2 p-5 rounded-xl border-2 transition-all ${
                formData.source_system === system.id
                  ? 'border-primary bg-primary/5'
                  : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
              }`}
            >
              <span className={`material-symbols-outlined text-3xl ${
                formData.source_system === system.id ? 'text-primary' : 'text-gray-400'
              }`}>
                {system.icon}
              </span>
              <span className={`text-sm font-bold ${
                formData.source_system === system.id ? 'text-primary' : 'text-[#111418]'
              }`}>
                {system.name}
              </span>
              <span className="text-xs text-gray-500 text-center">{system.description}</span>
              {formData.source_system === system.id && (
                <span className="material-symbols-outlined text-primary text-sm">check_circle</span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Informational Footer */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-6 border-t border-gray-100">
        <div className="flex flex-col gap-2 p-4 rounded-xl border border-dashed border-gray-200">
          <span className="material-symbols-outlined text-primary">verified_user</span>
          <h4 className="text-sm font-bold text-[#111418]">Secure Data Bridge</h4>
          <p className="text-xs text-gray-500">All migration data is encrypted with AES-256 standard and GDPR compliant.</p>
        </div>
        <div className="flex flex-col gap-2 p-4 rounded-xl border border-dashed border-gray-200">
          <span className="material-symbols-outlined text-primary">history</span>
          <h4 className="text-sm font-bold text-[#111418]">Historical Access</h4>
          <p className="text-xs text-gray-500">Migrate up to 7 years of historical financial data automatically.</p>
        </div>
        <div className="flex flex-col gap-2 p-4 rounded-xl border border-dashed border-gray-200">
          <span className="material-symbols-outlined text-primary">support_agent</span>
          <h4 className="text-sm font-bold text-[#111418]">Concierge Support</h4>
          <p className="text-xs text-gray-500">Dedicated support for complex chart-of-account mapping issues.</p>
        </div>
      </div>
    </div>
  )
}

export default StepMigrationDetails
